import { createSlice } from 'redux-starter-kit';
import apiClient from '../Api/api_client';
import { entrySlice } from './EntryStore';
import { loadingSlice } from './LoadingStore';

export const defaultFastPlayTicketState = {
    gameOver: false,
    success: false,
    message: '',
    code: '',
};

// REDUCERS
// basic actions that affect this object only

const enterFastPlayTicketReducer = (state, action) => {
    return {
        ...state,
        success: action.payload.success,
        message: action.payload.message,
        code: action.payload.code,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultFastPlayTicketState,
    };
};

const setGameOverReducer = (state, action) => {
    return {
        ...state,
        gameOver: action.payload.gameOver,
    };
};

export const fastPlayTicketSlice = createSlice({
    name: 'fastPlayTicket',
    initialState: defaultFastPlayTicketState,
    reducers: {
        enterFastPlayTicket: enterFastPlayTicketReducer,
        reset: resetReducer,
        setGameOver: setGameOverReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const enterFastPlayTicket = async (dispatch, payload) => {
    dispatch(
        loadingSlice.actions.setLoading({ action: 'enterFastPlayTicket' })
    );
    const result = await apiClient().enterFastPlayTicket(payload);
    if (result.success) {
        dispatch(entrySlice.actions.setLastEntry(result.entry));
    }
    dispatch(fastPlayTicketSlice.actions.enterFastPlayTicket(result));
    dispatch(
        loadingSlice.actions.unsetLoading({ action: 'enterFastPlayTicket' })
    );
};

const setGameOver = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'setGameOver' }));
    const result = await apiClient().getGameOver(payload);
    dispatch(fastPlayTicketSlice.actions.setGameOver(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'setGameOver' }));
};

//actions that get exported to the views
export const fastPlayTicketActions = dispatch => {
    return {
        enterFastPlayTicket: payload => enterFastPlayTicket(dispatch, payload),
        reset: payload => dispatch(fastPlayTicketSlice.actions.reset()),
        setGameOver: payload => setGameOver(dispatch, payload),
    };
};
